module.exports = __webpack_public_path__ + "static/media/loader3.48f804df.gif";